<template>
  <div>
    <table-component
      :model="model"
    />
  </div>
</template>

<script>
import TableComponent from '@/dc-it/components/TableComponent.vue'
import EventType from '@/dc-it/models/EventType'

export default {
  name: 'EventTypesView',
  components: { TableComponent },
  data() {
    return {
      model: EventType,
    }
  },
}
</script>

<style scoped>

</style>
